import SupportTicket from '../../ideaNiv/right-bar/evidence-card/calls-tickets-modals/Support-ticket/SupportTicket';
import GongCall from '../../ideaNiv/right-bar/evidence-card/calls-tickets-modals/Gong-call/GongCall';
import SlackConversation from '../../ideaNiv/right-bar/evidence-card/calls-tickets-modals/Slack-conversation/SlackConversation';
import ProductBoardTicket from '../../ideaNiv/right-bar/evidence-card/calls-tickets-modals/ProductBoardTicket';
import EngagementNotes from '../../ideaNiv/right-bar/evidence-card/calls-tickets-modals/engagment-notes/EngagementNotes';
import Survey from '../../ideaNiv/right-bar/evidence-card/calls-tickets-modals/survey/Survey';
import { DiscoveryCardTextArea } from './DiscoveryCardTextArea';
import type { DiscoveryEvidenceBodyKind } from './discoveryEvidenceBodyKind';

export function DiscoveryEvidenceBodyByKind({
  kind,
  item,
  isLoadingMl = false,
  suppressTitle,
}: {
  kind: DiscoveryEvidenceBodyKind;
  item: any;
  isLoadingMl?: boolean;
  suppressTitle?: boolean;
}) {
  switch (kind) {
  case 'gong_call':
    return <GongCall item={item} isLoadingMl={isLoadingMl} />;
  case 'survey':
    return <Survey item={item} />;
  case 'engagement_notes':
    return <EngagementNotes item={item} />;
  case 'slack':
    return <SlackConversation item={item} />;
  case 'support_ticket':
    return <SupportTicket item={item} isLoadingMl={isLoadingMl} />;
  case 'productboard':
    return <ProductBoardTicket item={item} isLoadingMl={isLoadingMl} />;
  case 'generic':
    return (
      <DiscoveryCardTextArea
        item={item}
        isLoadingMl={isLoadingMl}
        suppressTitle={suppressTitle}
      />
    );
  }
}
